// extracted by mini-css-extract-plugin
export default {"icon_wrapper":"callout_icon_wrapper__FbE-u"};